module.exports = __webpack_public_path__ + "img/insurance-logo-7.0ec5648b.png";